/* Cart add-on toggle — native replacement for UpCart's productAddon module.

   Adds or removes one configured product from the cart. State is never held
   in JS: the row is re-rendered by the theme's refreshQuickCart() after every
   cart change, so `checked` always reflects the real cart.

   Refresh is triggered with the theme's own public hook — quick-cart.js binds
   `apps:product-added-to-cart` on document specifically so integrations can
   ask it to re-render (see the QuickCart events array in theme.js). */
(function () {
  var BUSY = 'is-busy';

  function routes() {
    var r = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
    return {
      add: (r.add || '/cart/add') + '.js',
      change: (r.change || '/cart/change') + '.js'
    };
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('cart request failed: ' + res.status);
      return res.json();
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-addon-toggle]');
    if (!input) return;

    var row = input.closest('[data-cart-addon]');
    if (!row || row.classList.contains(BUSY)) return;

    var variantId = row.getAttribute('data-addon-variant-id');
    var lineKey = row.getAttribute('data-addon-line-key');
    if (!variantId) return;

    row.classList.add(BUSY);
    input.disabled = true;

    var request = input.checked
      ? post(routes().add, { items: [{ id: Number(variantId), quantity: 1 }] })
      : post(routes().change, { id: lineKey || variantId, quantity: 0 });

    request
      .then(function () {
        /* Let the theme re-render the drawer; the fresh markup carries the
           correct checked state and line key, so nothing is set here. */
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      })
      .catch(function () {
        /* Put the switch back where the cart actually is, rather than leaving
           it showing a change that did not happen. */
        input.checked = !input.checked;
      })
      .then(function () {
        row.classList.remove(BUSY);
        input.disabled = false;
      });
  });
})();
